const ORIGIN = 'https://carmenlorraine.com';

const LOCAL_BUSINESS = {
  name: 'Carmen Lorraine Photography',
  email: 'hello@carmenlorraine.com',
  telephone: '+27-82-415-1652',
  phoneDisplay: '082 415 1652',
  phoneTel: 'tel:+27824151652',
  instagram: 'https://www.instagram.com/carmenlorrainephotography/',
  mapsUrl: 'https://maps.google.com/?cid=13881823598113956691',
  mapsEmbed: 'https://www.google.com/maps?cid=13881823598113956691&output=embed',
  reviewUrl: 'https://search.google.com/local/writereview?placeid=ChIJjWXSBLdrzB0RU6M3cAMlpsA',
  streetAddress: 'Beach Rd, Chapmans Peak',
  addressLocality: 'Cape Town',
  addressRegion: 'Western Cape',
  postalCode: '7979',
  addressCountry: 'ZA',
  latitude: -34.0991,
  longitude: 18.3707,
  logo: 'https://res.cloudinary.com/di1mzmlts/image/upload/v1767339554/carmen_lorraine_photos/logos/yk0e7dossm5jxaem7pmj.png',
  areas: [
    'Cape Town',
    'Noordhoek',
    'Hout Bay',
    'Constantia',
    'Southern Suburbs',
    'Sea Point',
    'Stellenbosch',
  ],
};

const DEFAULT_WHERE_I_SHOOT_LINKS = [
  { label: 'family', href: '/galleries/family' },
  { label: 'business and commercial', href: '/galleries/business-and-commercial' },
  { label: 'lifestyle', href: '/galleries/lifestyle' },
];

const FOOTER_COPY_DEFAULTS = {
  footerLocality: 'Noordhoek, Cape Town',
  areasServed: LOCAL_BUSINESS.areas.join(', '),
  reviewLabel: 'Leave us a Google review',
  reviewUrl: LOCAL_BUSINESS.reviewUrl,
  whereIShootHeading: 'Where I shoot',
  whereIShootBody: 'Carmen Lorraine photographs across Cape Town, including Noordhoek, Hout Bay, Constantia, the Southern Suburbs, Sea Point, and Stellenbosch. Family sessions, business headshots, and lifestyle portraits are made on location around the peninsula.',
  whereIShootLinks: DEFAULT_WHERE_I_SHOOT_LINKS,
};

function escapeHtml(value) {
  return String(value || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

function nonEmpty(value, fallback) {
  const text = String(value || '').replace(/\s+/g, ' ').trim();
  return text || fallback;
}

function cleanAreas(value) {
  const source = Array.isArray(value) ? value : String(value || '').split(',');
  const areas = [];
  source.forEach((item) => {
    const name = String(item || '').replace(/\s+/g, ' ').trim();
    if (!name || name.length > 80 || areas.length >= 20) return;
    if (areas.some((existing) => existing.toLowerCase() === name.toLowerCase())) return;
    areas.push(name);
  });
  return areas;
}

function safeGalleryPath(href) {
  const value = String(href || '').trim();
  if (!/^\/[A-Za-z0-9][A-Za-z0-9\-/]*$/.test(value)) return '';
  if (value.includes('//') || value.includes('..')) return '';
  return value;
}

function sanitizeWhereIShootLinks(value) {
  if (!Array.isArray(value)) return null;
  const links = [];
  value.forEach((item) => {
    if (!item || typeof item !== 'object' || links.length >= 6) return;
    const label = String(item.label || '').replace(/\s+/g, ' ').trim().slice(0, 80);
    const href = safeGalleryPath(item.href);
    if (!label || !href) return;
    links.push({ label, href });
  });
  return links.length ? links : null;
}

function safeReviewUrl(value) {
  const raw = String(value || '').trim();
  // Saved site content still has the old g.page shortcut. The footer uses the write-review form.
  if (!raw || raw === 'https://g.page/r/CVOjN3ADJabAEBM/review') return LOCAL_BUSINESS.reviewUrl;
  try {
    const url = new URL(raw);
    const host = url.hostname.toLowerCase();
    const allowed = url.protocol === 'https:' && (
      host === 'g.page'
      || host === 'google.com'
      || host.endsWith('.google.com')
      || host === 'goo.gl'
      || host === 'maps.app.goo.gl'
    );
    if (!allowed) return LOCAL_BUSINESS.reviewUrl;
    return url.toString();
  } catch (error) {
    return LOCAL_BUSINESS.reviewUrl;
  }
}

function validEmail(value) {
  const email = String(value || '').trim();
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) || email.length > 120) return '';
  return email;
}

function phonePresentation(value) {
  const fallback = {
    display: LOCAL_BUSINESS.phoneDisplay,
    tel: LOCAL_BUSINESS.phoneTel,
    schema: LOCAL_BUSINESS.telephone,
  };
  const raw = String(value || '').trim();
  const digitsOnly = raw.replace(/\D/g, '');
  if (!raw || raw.includes('123 4567') || raw.includes('123456789') || digitsOnly.length < 10) {
    return fallback;
  }
  let digits = digitsOnly;
  if (digits.startsWith('270') && digits.length > 11) digits = `27${digits.slice(3)}`;
  if (digits.startsWith('0')) digits = `27${digits.slice(1)}`;
  if (!digits.startsWith('27') || digits.length < 11) return fallback;
  const national = digits.slice(2);
  const studioNumber = national === '824151652';
  return {
    display: studioNumber ? LOCAL_BUSINESS.phoneDisplay : raw,
    tel: `tel:+${digits}`,
    schema: studioNumber
      ? LOCAL_BUSINESS.telephone
      : `+${digits.slice(0, 2)}-${digits.slice(2, 4)}-${digits.slice(4, 7)}-${digits.slice(7)}`,
  };
}

function footerModel(content) {
  const source = content && typeof content === 'object' ? content : {};
  const areas = cleanAreas(source.areasServed);
  const areaList = areas.length ? areas : LOCAL_BUSINESS.areas.slice();
  const phone = phonePresentation(source.contactPhone);
  return {
    name: nonEmpty(source.studioName, LOCAL_BUSINESS.name).slice(0, 120),
    email: validEmail(source.contactEmail) || LOCAL_BUSINESS.email,
    phoneDisplay: phone.display,
    phoneTel: phone.tel,
    telephone: phone.schema,
    locality: nonEmpty(source.footerLocality, FOOTER_COPY_DEFAULTS.footerLocality).slice(0, 160),
    areas: areaList,
    placeLine: `${nonEmpty(source.footerLocality, FOOTER_COPY_DEFAULTS.footerLocality).slice(0, 160)} · ${areaList.join(', ')}`,
    reviewLabel: nonEmpty(source.reviewLabel, FOOTER_COPY_DEFAULTS.reviewLabel).slice(0, 80),
    reviewUrl: safeReviewUrl(source.reviewUrl || LOCAL_BUSINESS.reviewUrl),
  };
}

function whereIShootModel(content) {
  const source = content && typeof content === 'object' ? content : {};
  const links = sanitizeWhereIShootLinks(source.whereIShootLinks)
    || DEFAULT_WHERE_I_SHOOT_LINKS.map((link) => ({ label: link.label, href: link.href }));
  return {
    heading: nonEmpty(source.whereIShootHeading, FOOTER_COPY_DEFAULTS.whereIShootHeading).slice(0, 120),
    body: nonEmpty(source.whereIShootBody, FOOTER_COPY_DEFAULTS.whereIShootBody).slice(0, 2000),
    links,
  };
}

function imageObject(photo) {
  if (!photo || typeof photo !== 'object') return null;
  const contentUrl = String(photo.contentUrl || photo.src || photo.url || '');
  const url = String(photo.url || photo.src || contentUrl || '');
  if (!contentUrl.startsWith('https://') || !url.startsWith('https://')) return null;
  const caption = String(photo.caption || photo.alt || '').replace(/\s+/g, ' ').trim();
  return {
    '@type': 'ImageObject',
    contentUrl,
    url,
    caption,
    creditText: 'Carmen Lorraine',
  };
}

function schemaImages(options) {
  const source = options && Array.isArray(options.images) ? options.images : [];
  return source.map(imageObject).filter(Boolean);
}

function professionalServiceNode(content, options) {
  const business = LOCAL_BUSINESS;
  const published = footerModel(content);
  const images = schemaImages(options);
  const node = {
    '@type': 'ProfessionalService',
    '@id': `${ORIGIN}/#business`,
    name: published.name,
    url: `${ORIGIN}/`,
    image: images.length ? images : business.logo,
    email: published.email,
    telephone: published.telephone,
    address: {
      '@type': 'PostalAddress',
      streetAddress: business.streetAddress,
      addressLocality: business.addressLocality,
      addressRegion: business.addressRegion,
      postalCode: business.postalCode,
      addressCountry: business.addressCountry,
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: business.latitude,
      longitude: business.longitude,
    },
    hasMap: business.mapsUrl,
    areaServed: published.areas.map((name) => ({ '@type': 'City', name })),
    sameAs: [business.instagram, business.mapsUrl],
    founder: { '@id': `${ORIGIN}/#carmen` },
  };
  if (images.length) node.logo = business.logo;
  if (node.price == null) node.priceRange = '$$';
  return node;
}

function businessSchema(content, options) {
  const published = footerModel(content);
  const businessId = `${ORIGIN}/#business`;
  const personId = `${ORIGIN}/#carmen`;
  const images = schemaImages(options);
  const graph = [
    professionalServiceNode(content, options),
    {
      '@type': 'Person',
      '@id': personId,
      name: 'Carmen Lorraine',
      jobTitle: 'Photographer',
      url: `${ORIGIN}/about`,
      email: published.email,
      worksFor: { '@id': businessId },
      sameAs: [LOCAL_BUSINESS.instagram],
    },
  ];
  if (options && options.pagePath === '/' && images.length) {
    graph.push({
      '@type': 'WebPage',
      '@id': `${ORIGIN}/#webpage`,
      url: `${ORIGIN}/`,
      name: published.name,
      primaryImageOfPage: images[0],
    });
  }
  return {
    '@context': 'https://schema.org',
    '@graph': graph,
  };
}

function applyPublishedBusiness(schema, content) {
  if (!schema || !content) return schema;
  const published = footerModel(content);
  const copy = JSON.parse(JSON.stringify(schema));
  const visit = (node) => {
    if (!node || typeof node !== 'object') return;
    if (Array.isArray(node)) {
      node.forEach(visit);
      return;
    }
    const types = Array.isArray(node['@type']) ? node['@type'] : [node['@type']];
    if (types.includes('ProfessionalService')) {
      if (node.name) node.name = published.name;
      if (node.email) node.email = published.email;
      if (node.telephone) node.telephone = published.telephone;
      if (node.areaServed || String(node['@id'] || '').endsWith('#business')) {
        node.areaServed = published.areas.map((name) => ({ '@type': 'City', name }));
      }
    }
    if (types.includes('Person') && String(node['@id'] || '').endsWith('#carmen') && node.email) {
      node.email = published.email;
    }
    Object.values(node).forEach(visit);
  };
  visit(copy);
  return copy;
}

function siteFooterHtml(content) {
  const business = footerModel(content);
  return `<footer class="site-footer"><div class="site-footer-business"><p class="site-footer-name">${escapeHtml(business.name)}</p><p class="site-footer-place">${escapeHtml(business.placeLine)}</p><p class="site-footer-contact"><a href="${escapeHtml(business.phoneTel)}">${escapeHtml(business.phoneDisplay)}</a> <a href="mailto:${escapeHtml(business.email)}">${escapeHtml(business.email)}</a> <a href="${escapeHtml(business.reviewUrl)}" target="_blank" rel="noopener noreferrer">${escapeHtml(business.reviewLabel)}</a></p></div><nav class="site-footer-nav" aria-label="Footer"><a href="/galleries">Galleries</a> <a href="/blog">Blog</a> <a href="/#about">About</a> <a href="/contact">Contact</a></nav></footer>`;
}

function browseHtml(links) {
  if (!links.length) return '';
  const anchors = links.map((link) => `<a href="${escapeHtml(link.href)}">${escapeHtml(link.label)}</a>`);
  if (anchors.length === 1) return `Browse the ${anchors[0]} gallery.`;
  const last = anchors.pop();
  return `Browse the ${anchors.join(', ')}, and ${last} galleries.`;
}

function whereIShootHtml(content) {
  const section = whereIShootModel(content);
  const browse = browseHtml(section.links);
  return `<section class="where-we-shoot"><h2>${escapeHtml(section.heading)}</h2><p>${escapeHtml(section.body)}${browse ? ` ${browse}` : ''}</p></section>`;
}

function whereWeShootHtml(content) {
  return whereIShootHtml(content);
}

function whatsappDigits(phone) {
  const value = String(phone || '');
  const useStudioNumber = !value
    || value.includes('123 4567')
    || value.includes('123456789')
    || value.length < 10
    || value === '+27 (0) 82 415 1652'
    || value === '+27 82 415 1652';
  return (useStudioNumber ? LOCAL_BUSINESS.telephone : value).replace(/[^\d]/g, '');
}

function whatsappHref(phone, text) {
  const digits = whatsappDigits(phone);
  if (!text) return `https://wa.me/${digits}`;
  return `https://wa.me/${digits}?text=${encodeURIComponent(text)}`;
}

function contactLocalHtml(content) {
  const business = LOCAL_BUSINESS;
  const published = footerModel(content);
  const based = published.locality.split(',')[0].trim() || 'Noordhoek';
  return `<p class="contact-area">Based in ${escapeHtml(based)}, shooting across Cape Town — ${escapeHtml(published.areas.join(', '))}.</p><div class="contact-map"><iframe src="${escapeHtml(business.mapsEmbed)}" loading="lazy" title="Carmen Lorraine Photography on Google Maps"></iframe></div><p><a href="${escapeHtml(business.mapsUrl)}" target="_blank" rel="noopener noreferrer">View on Google Maps</a></p><p><a class="contact-review" href="${escapeHtml(published.reviewUrl)}" target="_blank" rel="noopener noreferrer">${escapeHtml(published.reviewLabel)}</a></p>`;
}

module.exports = {
  LOCAL_BUSINESS,
  FOOTER_COPY_DEFAULTS,
  footerModel,
  whereIShootModel,
  sanitizeWhereIShootLinks,
  imageObject,
  professionalServiceNode,
  businessSchema,
  applyPublishedBusiness,
  siteFooterHtml,
  whereIShootHtml,
  whereWeShootHtml,
  contactLocalHtml,
  whatsappDigits,
  whatsappHref,
};
